import React from "react";
import myPhoto1 from "../../../assets/images/myPhoto1.png";
import Typewriter from "typewriter-effect";
import { Container } from "react-bootstrap";

const TopBanner = () => {
  return (
    <div>
      <div className="top-banner">
        <Container>
          <div className="row">
            <div className="col-md-6 banner-txt">
              <div>
                <h2 className="primary-color">Hello I'm </h2>
                <h2 className="third-color">Md Hasibuzzaman </h2>
                <p className="third-color">
                  <Typewriter
                    options={{
                      strings: [
                        "A Full-Stack web developer",
                        "MERN stack developer",
                      ],
                      autoStart: true,
                      loop: true,
                    }}
                  />
                </p>
                <p className="third-color banner-description">
                  I'm a Proactive M.E.R.N Stack Developer fascinated by Web
                  Technologies. I have a deep interest in JavaScript and am
                  looking for opportunities to make the best use of my skills
                  and learn more.
                </p>
                <a href="#portfolio">
                  <button className="primary-btn">Portfolio</button>
                </a>
                <a href="https://drive.google.com/file/d/1s-mphrlSPnZWsUGJNii0XpT4M4yOkMAt/view?usp=sharing">
                  <button className="primary-btn">Resume</button>
                </a>
              </div>
            </div>

            <div className="col-md-6 image-sec">
              <img width="350px" src={myPhoto1} alt="" />
            </div>
          </div>
        </Container>
      </div>
    </div>
  );
};

export default TopBanner;
